// import React from 'react'

// const Readiness = () => {
//     return <>
//     <div className='sectionContainer'>
//         <div className="remoteWorkReadiness">
//             <h2 className="sectionTitle">Remote Work Readiness</h2>
//             <p className="introText">
//                 As a Full-Stack Developer with proven experience in remote collaboration, I’m fully equipped to contribute effectively from any location. Here’s what you can expect when working with me: 🌍
//             </p>
//             <ul className="readinessList">
//                 <li><strong>Flexible Availability:</strong> Ready to start immediately and comfortable with working across time zones and adjusting schedules to meet team needs.</li>
//                 <li><strong>Effective Communication:</strong> Skilled in using tools like Slack, Zoom, and GitHub for seamless, real-time collaboration.</li>
//                 <li><strong>Adaptability:</strong> Quick to learn and adjust to new tools, environments, and team dynamics, ensuring smooth transitions.</li>
//                 <li><strong>Proven Remote Experience:</strong> Consistently delivered high-quality remote projects on time while fostering strong team collaboration.</li>
//                 <li><strong>Self-Discipline & Time Management:</strong> Able to prioritize tasks, meet deadlines, and maintain peak productivity with minimal supervision.</li>
//                 <li><strong>Cultural Sensitivity:</strong> Sensitive to diverse cultures and team dynamics, promoting respectful and efficient collaboration.</li>
//                 <li><strong>Reliable Setup:</strong> Equipped with a dedicated, distraction-free workspace and high-speed tech to support seamless remote work.</li>
//             </ul>
//             <div className='btnContainer'>
//                 <a href='#Contact' className='primaryBtn'>Let's Connect</a>
//             </div>
//         </div>
//     </div>
//     </>
// }

// export default Readiness

import React from 'react';

const Readiness = () => {
  return (
    <>
      <div className="sectionContainer">
        <div className="remoteWorkReadiness">
          <h2 className="sectionTitle">Remote Work Readiness</h2>
          <p className="introText">
            I have experience working remotely with international teams and
            collaborating across different roles and time zones. I’m comfortable
            taking ownership of my work while staying closely aligned with the
            team.
          </p>

          <ul className="readinessList">
            <li>
              <strong>Remote Collaboration:</strong> Experienced working with
              international teams across the United States and United Kingdom
              using modern collaboration and development workflows.
            </li>
            <li>
              <strong>Clear Communication:</strong> Comfortable communicating
              technical decisions, requirements, progress, and blockers with
              developers, designers, DevOps, researchers, and non-technical
              stakeholders.
            </li>
            <li>
              <strong>Self-Directed Work:</strong> Able to independently
              investigate problems, learn unfamiliar technologies, and move
              tasks forward without requiring constant supervision.
            </li>
            <li>
              <strong>Ownership & Accountability:</strong> Comfortable taking
              responsibility for features and systems from understanding
              requirements through implementation and delivery.
            </li>
            <li>
              <strong>Adaptability:</strong> Quick to adapt to new technologies,
              codebases, workflows, and changing product requirements.
            </li>
            <li>
              <strong>Time Management:</strong> Experienced prioritizing work,
              managing deadlines, and making practical trade-offs when working
              in fast-paced environments.
            </li>
          </ul>

          <div className="btnContainer">
            <a href="#Contact" className="primaryBtn">
              Let's Connect
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Readiness;
